import {TranslateService} from '@ngx-translate/core';
import {ContactlessType} from '../pro-tasks-manager/form/pro-tasks-form-state.service';
import {PoiUnveroEntry} from '../pro-tasks-manager/form/model/unvero/poi-unvero.entry';
import {ProductPrice} from '../pro-tasks-manager/form/properties/fuel-chart/fuel-calculation.utils';

const UNVERO_MOBILE_PAYMENT_TYPE = 'mobile';
const UNVERO_CARD_AND_MOBILE_PAYMENT_TYPE = 'card_and_mobile';
const UNVERO_MOBILE_PAYMENT_TYPES = [UNVERO_MOBILE_PAYMENT_TYPE, UNVERO_CARD_AND_MOBILE_PAYMENT_TYPE];

const UNVERO_PRODUCT_DIESEL = 'DIESEL';
const UNVERO_PRODUCT_ADBLUE = 'AD BLUE';
const UNVERO_PRODUCT_LNG = 'gplc';

const UNVERO_BRAND_TO_CONTACTLESS: Record<string, ContactlessType> = {
  SHELL: 'SHELL',
  Viada: 'VIADA',
  BP: 'VIADA',
  Milda: 'VIADA',
  Kvistija: 'VIADA',
  Abromika: 'VIADA',
  AS24: 'AS24',
  CircleK: 'CIRCLE_K',
};

export class UnveroUtils {

  public static pricesToShow(station: PoiUnveroEntry, pricesToUse: ProductPrice[]): number {
    if (station.totalCost != null && station.totalCost > 0) {
      return station.totalCost;
    }
    let sum = 0;
    for (const priceToUse of pricesToUse || []) {
      sum += this.priceToShow(station, priceToUse);
    }
    return +sum.toFixed(4);
  }

  public static priceToShow(station: PoiUnveroEntry, priceToUse: ProductPrice): number {
    if (priceToUse === 'diesel') {
      return this.getDieselPrice(station);
    } else if (priceToUse === 'adBlue') {
      return this.getAdBluePrice(station);
    } else if (priceToUse === 'lng') {
      return this.getLngPrice(station);
    }
    return 0;
  }

  public static resolveUnveroProductName(priceToUse: ProductPrice): string | null {
    if (priceToUse === 'diesel') {
      return UNVERO_PRODUCT_DIESEL;
    } else if (priceToUse === 'adBlue') {
      return UNVERO_PRODUCT_ADBLUE;
    } else if (priceToUse === 'lng') {
      return UNVERO_PRODUCT_LNG;
    }
    return null;
  }

  public static stationMatchesUnveroSelection(station: PoiUnveroEntry, pricesToUse: ProductPrice[]): boolean {
    if (station.products?.length > 0) {
      for (const priceToUse of pricesToUse || []) {
        let productName = this.resolveUnveroProductName(priceToUse);
        if (productName != null
          && station.products.some(product => product.name === productName && product.price > 0)) {
          return true;
        }
      }
    }
    return false;
  }

  private static getDieselPrice(station: PoiUnveroEntry): number {
    let dieselProduct = station.products.find(it => it.name === UNVERO_PRODUCT_DIESEL);
    return dieselProduct?.price != null && dieselProduct.price > 0 ? dieselProduct.price : 0;
  }

  private static getAdBluePrice(station: PoiUnveroEntry): number {
    let adBlueProduct = station.products.find(it => it.name === UNVERO_PRODUCT_ADBLUE);
    return adBlueProduct?.price != null && adBlueProduct.price > 0 ? adBlueProduct.price : 0;
  }

  private static getLngPrice(station: PoiUnveroEntry): number {
    let lngProduct = station.products.find(it => it.name === UNVERO_PRODUCT_LNG);
    return lngProduct?.price != null && lngProduct.price > 0 ? lngProduct.price : 0;
  }

  public static resolveUnveroContactless(station: PoiUnveroEntry): ContactlessType | null {
    return station != null
    && station.externalPoiId != null
    && station.paymentType != null
    && station.brand != null
    && UNVERO_MOBILE_PAYMENT_TYPES.includes(station.paymentType)
    && UNVERO_BRAND_TO_CONTACTLESS[station.brand] != null
      ? UNVERO_BRAND_TO_CONTACTLESS[station.brand] ?? null
      : null;
  }

  public static resolveUnveroFuelIcon(station: PoiUnveroEntry): string {
    return this.resolveUnveroContactless(station) != null
      ? 'assets/img/proTasks/markers/fuelStations/cardlessStation.svg'
      : 'assets/img/proTasks/markers/fuelStations/fuelStation.svg';
  }

  public static appendContactlessInfo(
    info: {content: string, bubbleHeight: number},
    station: PoiUnveroEntry,
    translate: TranslateService): void {

    if (this.resolveUnveroContactless(station) != null) {
      this.appendContactlessLine(info, translate.instant('fueling.contactless'));
      if (station.paymentType === UNVERO_MOBILE_PAYMENT_TYPE) {
        this.appendContactlessLine(info, translate.instant('fueling.contactlessOnly'));
      }
    }
  }

  private static appendContactlessLine(
    info: {content: string, bubbleHeight: number},
    label: string): void {

    info.content += '<div class="info-line"><span class="info-label">'
      + label
      + `</span>: <i class="ico-check c-green"></i></div>`;
    info.bubbleHeight += 13;
  }
}
